export default {"src":"/_next/static/media/tiktok.0b0fa094.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};